import { api, PartipostApiResponse } from './'

export const RegisterActions = {
    VALIDATE_IS_EMAIL_EXISTED_REQUEST: 'register/VALIDATE_IS_EMAIL_EXISTED_REQUEST',
    SIGN_UP: 'register/SIGN_UP:',
    SEND_INVITE: 'register/SEND_INVITE',
    SIGN_UP_DETAILS: 'register/SIGN_UP_DETAILS',
    MASS_INVITE: 'register/MASS_INVITE',
} as const

export interface ValidateIsEmailPayloads {
    email: string
    onSuccess: (isExist: boolean) => void
}
export interface ValidateIsEmailResponse {
    exists: boolean
    platform: 'app' | 'cm'
}

export const validateIsEmailExist = (payload: ValidateIsEmailPayloads) => {
    const { email } = payload
    return api.get<PartipostApiResponse<ValidateIsEmailResponse>>(`/members/check-existing-email?email=${email}`)
}

export interface SignUpPayloads {
    email: string
    password1: string
    password2: string
    onSuccess: () => void
    onError?: () => void
}

export const signUp = (payload: SignUpPayloads) => {
    return api.post<PartipostApiResponse<any>>('/auth/signup/', {
        email: payload.email,
        password1: payload.password1,
        password2: payload.password2,
    })
}

export type SendInvitePayloads =
    | {
          email: string
      }
    | { member_uuid: string }

export const sendInvite = (payload: SendInvitePayloads) => {
    return api.post<PartipostApiResponse<any>>('/members/send-invite/', payload)
}

export type CheckMemberIdPayloads = {
    memberUuid: string
    onSuccess: (res: any) => void
    onError?: () => void
}

export type SignUpDetailsPayloads = {
    data: {
        username: string
        company_name: string
        business_type: string
        industry: string
        industry_others: null | string
        country: string
    }
    onSuccess: () => void
    onError: () => void
}

export const signUpDetails = (payload: SignUpDetailsPayloads) => {
    return api.post<PartipostApiResponse<any>>(`/members/register/`, payload.data)
}

export type InviteTeamMembersPayloads = {
    data: {
        username: string
        email: string
    }[]
    onSuccess: () => void
    onError: () => void
}

export const inviteTeamMembers = (payload: InviteTeamMembersPayloads) => {
    return api.post<PartipostApiResponse>(`/members/mass-invite/`, payload.data)
}
